'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

var _angularUiRouter = require('angular-ui-router');

var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);

var _sentqueries = require('./sentqueries.component');

var _sentqueries2 = _interopRequireDefault(_sentqueries);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var sentqueriesModule = _angular2.default.module('sentqueries', [_angularUiRouter2.default]).component('sentqueries', _sentqueries2.default);

exports.default = sentqueriesModule;


// WEBPACK FOOTER //
// ./client/app/common/reports/sentqueries/sentqueries.js